import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.parse-int.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import env from '@tencent/vft-common/env';
import Version from '@tencent/vft-common/Version';
import tenvideo from '@tencent/vft-common/tenvideo';
import Onview from '@tencent/vft-onview';
import Share from './share';
import Scroll from '../AreaCode/scroll.vue';
import PwdDialog, { getPwd } from '../PwdDialog';
import { xqeShare } from './xqe-share';
import atom from '@tencent/vft-atom';
import qqsports from '@tencent/vft-atom/qqsports';
Vue.use(PwdDialog);
var SUPPORTED_APP_VERSION = '6.9.0';
var SUPPORTED_KID_VERSION = '6.4.0';
export default {
  name: 'VuIconshare',
  components: {
    Scroll: Scroll
  },
  props: {
    dc: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    shareInfo: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    pwdInfo: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    paddingLeft: {
      type: String,
      "default": '38px'
    },
    reportModule: {
      type: String,
      "default": ''
    },
    usePwd: {
      type: Boolean
    },
    onPwdCancel: {
      type: Function
    },
    wrap: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      isTenvideo: env.isApp,
      isQQSports: env.isQQSports,
      appVersion: new Version(tenvideo.getAppVersion() || '0.0.0'),
      channelName: {
        save: '保存本地',
        weixin: '微信',
        wxmoments: '朋友圈',
        doki: 'doki',
        qq: 'QQ',
        qzone: 'QQ空间',
        weibo: '微博'
      }
    };
  },
  computed: {
    channels: function channels() {
      var _this = this;

      var channels = [{
        id: 'save'
      }, {
        id: 'weixin',
        usePwd: this.usePwd && !this.useMiniProgram
      }, {
        id: 'wxmoments',
        usePwd: this.usePwd
      }, {
        id: 'doki'
      }, {
        id: 'qq'
      }, {
        id: 'qzone'
      }, {
        id: 'weibo'
      }];

      if (!this.shareInfo.dokiId) {
        channels.splice(3, 1);
      } // 小企鹅6.4.0版本以下只支持分享链接 且只能分享微信 朋友圈
      // 小企鹅6.4.0版本以后支持分享图片，且可以保存本地


      if (env.isKidApp) {
        var commonChannels = [{
          id: 'weixin',
          usePwd: this.usePwd && !this.useMiniProgram
        }, {
          id: 'wxmoments',
          usePwd: this.usePwd
        }];

        if (this.appVersion.compare(SUPPORTED_KID_VERSION)) {
          channels = [{
            id: 'save'
          }].concat(commonChannels);
        } else {
          channels = commonChannels;
        }
      } // 腾讯体育


      if (this.isQQSports) {
        channels = [{
          id: 'weixin'
        }, {
          id: 'wxmoments'
        }, {
          id: 'qq'
        }, {
          id: 'qzone'
        }, {
          id: 'weibo'
        }];
      }

      if (Array.isArray(this.dc) && this.dc.length) {
        return channels.filter(function (channel) {
          return _this.dc.indexOf(channel.id) === -1;
        });
      }

      return channels;
    },
    useMiniProgram: function useMiniProgram() {
      return ['release', 'dev', 'preview'].indexOf(this.shareInfo.miniProgramType) >= 0;
    }
  },
  created: function created() {
    var _this2 = this;

    tenvideo.tenvideoReady(function () {
      TenvideoJSBridge.on('onShareFinish', function () {
        if (_this2.sharing) {
          _this2.$emit('shareFinish');

          _this2.sharing = false;
        }
      });
    });
  },
  updated: function updated() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$refs.scroll && _this3.$refs.scroll.refresh();
    });
  },
  methods: {
    saveImg: function saveImg(toast) {
      TenvideoJSBridge.invoke('saveImage', {
        imgbase64String: this.shareInfo.imgbase64,
        needSaveToAlbum: true
      }, function (res) {
        if (!toast) {
          return;
        }

        var json = JSON.parse(res);

        if (json && parseInt(json.errCode) === 0) {
          atom.toast('保存到相册成功');
        } else {
          atom.toast('保存到相册失败');
        }
      });
    },
    save: function save() {
      var _this4 = this;

      var toast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var authRes = {
        PASS: 1,
        // 有权限
        DENY: 0 // 无权限

      };

      try {
        if (this.appVersion.compare(new Version('8.5.5'))) {
          // 版本判断
          TenvideoJSBridge.invoke('checkAppPermission', {
            permissionList: ['photo']
          }, function (checkRes) {
            var _JSON$parse, _JSON$parse$result;

            if (((_JSON$parse = JSON.parse(checkRes)) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$result = _JSON$parse.result) === null || _JSON$parse$result === void 0 ? void 0 : _JSON$parse$result.photo) !== authRes.PASS) {
              TenvideoJSBridge.invoke('requestAppPermission', {
                permissionList: [{
                  permissionName: 'photo',
                  requestText: '保存分享图需要您授权使用保存相册权限，以便功能的正常使用',
                  deniedText: '您已拒绝授权使用保存相册权限，无法正常使用该功能，请重新授权'
                }]
              }, function (reqRes) {
                var _JSON$parse2, _JSON$parse2$result;

                if (((_JSON$parse2 = JSON.parse(reqRes)) === null || _JSON$parse2 === void 0 ? void 0 : (_JSON$parse2$result = _JSON$parse2.result) === null || _JSON$parse2$result === void 0 ? void 0 : _JSON$parse2$result.photo) === authRes.PASS) {
                  _this4.saveImg(toast);
                } else {
                  atom.toast('保存到相册失败，无权限');
                }
              });
            } else {
              _this4.saveImg(toast);
            }
          });
        } else {
          this.saveImg(toast);
        }
      } catch (e) {
        console.error('保存到相册失败', e);
        atom.toast('保存到相册失败');
      }
    },
    share: function share(channel) {
      // 参数重新定义为了对象，为了兼容老的字符串调用
      if (typeof channel === 'string') {
        channel = {
          id: channel
        };
      } // 小企鹅app内低于6.4.0在走特殊逻辑


      if (env.isKidApp && !this.appVersion.compare(SUPPORTED_KID_VERSION)) {
        if (channel.usePwd) {
          this.pwdShare(channel.id);
        } else {
          xqeShare(channel.id, this.shareInfo);
        }

        this.$emit('shareClick', channel.id);
        return;
      }

      if (!this.shareInfo.imgbase64) {
        return;
      }

      if (this.isQQSports) {
        return qqsports.shareTo({
          type: channel.id,
          imgbase64: this.shareInfo.imgbase64
        });
      }

      if (channel.id === 'save') {
        this.save();
        this.$emit('shareClick', channel.id);
      } else {
        if (channel.id !== 'doki' && !env.isLiteApp && !env.isKidApp && !this.appVersion.compare(SUPPORTED_APP_VERSION) && this.shareInfo.isShareImageOnly !== false) {
          this.toast && this.toast('当前app版本较低，请升级至6.9.0及以上版本', 5000);
          this.$emit('lowAppVer', '当前app版本较低，请升级至6.9.0及以上版本');
          return;
        }

        this.sharing = true;

        if (channel.usePwd) {
          this.pwdShare(channel.id);
        } else {
          Share.openShare(channel.id, _objectSpread({
            isShareImageOnly: true
          }, this.shareInfo));
        }

        this.$emit('shareClick', channel.id);
      }
    },
    pwdShare: function pwdShare(channel) {
      var _this5 = this;

      if (this.lockGetPwd) {
        return;
      }

      this.lockGetPwd = true;
      getPwd({
        pageId: this.pwdInfo.pageId,
        jumpUrl: this.pwdInfo.jumpUrl
      }).then(function (res) {
        _this5.$createPwdDialog({
          $props: {
            channel: channel,
            thumbpic: _this5.shareInfo.imgbase64,
            pwds: res[channel]
          },
          $events: {
            cancel: function cancel() {
              _this5.onPwdCancel && _this5.onPwdCancel();
            }
          }
        }).show();

        if (channel === 'wxmoments') {
          _this5.save(false);
        }

        _this5.$emit('popPwdDialog');
      }, function (e) {
        _this5.toast && _this5.toast('服务异常请重试');
      }).then(function () {
        _this5.lockGetPwd = false;
      });
    },
    scrollHandler: function scrollHandler() {
      Onview.triggerCompute();
    }
  },
  reportData: {
    save: {
      f_type: 4,
      f_resource: '保存本地btn'
    },
    weixin: {
      f_type: 4,
      f_resource: '分享微信btn'
    },
    wxmoments: {
      f_type: 4,
      f_resource: '分享朋友圈btn'
    },
    doki: {
      f_type: 4,
      f_resource: '分享dokibtn'
    },
    qq: {
      f_type: 4,
      f_resource: '分享QQbtn'
    },
    qzone: {
      f_type: 4,
      f_resource: '分享QQ空间btn'
    },
    weibo: {
      f_type: 4,
      f_resource: '分享微博btn'
    }
  }
};